import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Users, Key, Network, BarChart2 } from '../icons';
import { SidebarLayout } from './SidebarLayout';
import { RoleSwitcher } from '../RoleSwitcher';
import { useAuth } from '../../contexts/AuthContext';
import { isUserPartner } from '../../lib/auth';
import { LoadingSpinner } from '../LoadingSpinner';
import type { SidebarItem } from './Sidebar';

const partnerItems: SidebarItem[] = [
  { label: 'Dashboard', path: '/partner', icon: Brain },
  { label: 'Coaches', path: '/partner/coaches', icon: Users },
  { label: 'Teams', path: '/partner/teams', icon: Network },
  { label: 'Assessment Codes', path: '/partner/codes', icon: Key },
  { label: 'Analytics', path: '/partner/analytics', icon: BarChart2 },
];

export function PartnerLayout() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();
  const [authorized, setAuthorized] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/login');
      return;
    }

    isUserPartner(user.id).then((isPartner) => {
      if (!isPartner) {
        navigate('/');
        return;
      }
      setAuthorized(true);
      setChecking(false);
    });
  }, [user, authLoading, navigate]);

  if (authLoading || checking || !authorized) {
    return <LoadingSpinner message="Loading..." />;
  }

  return (
    <SidebarLayout
      items={partnerItems}
      title="Partner"
      subtitle="Manage coaches & teams"
      headerSlot={<RoleSwitcher currentRole="partner" />}
    />
  );
}
